import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import { CtaFieldType, ImageFieldType } from 'libs/contentful/types';

import styles from './SponsorModule.module.less';

type ArticleSponsor = {
  sponsorCta?: CtaFieldType;
  sponsorName?: string;
  sponsorAbout?: string;
  sponsorLogoImage?: ImageFieldType;
};

// TODO: find out which field determining
const SponsorModule: React.FC<ArticleSponsor> = ({
  sponsorCta,
  sponsorName,
  sponsorAbout,
  sponsorLogoImage,
}) => {
  return (
    <div className={styles.container}>
      {sponsorLogoImage && (
        <img src={sponsorLogoImage.src} alt={sponsorLogoImage.altText} loading="lazy" />
      )}
      <div className={styles.sponsorName}>About {sponsorName}</div>
      {sponsorAbout && (
        <ReactMarkdown
          source={sponsorAbout}
          escapeHtml={false}
          parserOptions={{ commonmark: true }}
        />
      )}
      <ButtonV3 className={styles.button} component="a" href={sponsorCta?.url}>
        {sponsorCta?.copy}
      </ButtonV3>
    </div>
  );
};

export default SponsorModule;
